import PropTypes from 'prop-types';
import Radium from 'radium';
import React from 'react';
import { Accordion } from 'react-accessible-accordion';
import stylesPropType from 'react-style-proptype';
import { twMerge } from 'tailwind-merge';

import Tokens from 'styles/tokens';

const AvomaAccordion = ({
  children,
  allowMultipleExpanded,
  allowZeroExpanded,
  style,
  key,
  className,
  preExpandedArray,
  ...rest
}) => (
  <Accordion
    className={twMerge('mt-2', className)}
    style={style}
    allowMultipleExpanded={allowMultipleExpanded}
    allowZeroExpanded={allowZeroExpanded}
    key={key}
    preExpanded={preExpandedArray}
    {...rest}
  >
    {children}
  </Accordion>
);

AvomaAccordion.propTypes = {
  children: PropTypes.node.isRequired,
  allowMultipleExpanded: PropTypes.bool,
  allowZeroExpanded: PropTypes.bool,
  style: stylesPropType,
  key: PropTypes.any,
  className: PropTypes.string,
  // Useful when you want a certain uuid to be expanded on accordion mount
  // Used in OnboardingSetup to programmatically open the next accordion item
  // on completion of the current task
  preExpandedArray: PropTypes.array
};

AvomaAccordion.defaultProps = {
  allowMultipleExpanded: false,
  allowZeroExpanded: false,
  preExpandedArray: []
};

export default Radium(AvomaAccordion);
